<template>
    <div class="page">
        <div class="page-bd">
            <div class="edit-box">
                <div class="f-bd f14 text-nowrap">{{$t('add_time')}}{{$t('x_mh')}}</div>
                <div class="mg-right10"><myDatePicker v-model="search.datearea_id" @onChange="onDateChange"></myDatePicker></div>
                <div class="mg-right10">
                    <Input v-model="search.mod_cname">
                        <span slot="prepend">{{$t('mod_cname')}}{{$t('x_yd')}}</span>
                    </Input>
                </div>
                <div class="mg-right10"><Button type="primary" @click="openAdd()">{{$t('add_mod')}}</Button></div>
                <div class="mg-right10"><Button type="primary" @click="list(false)">{{$t('list')}}</Button></div>
                <div class="mg-right10"><Button type="success" @click="exportExcel">{{$t('export')}}</Button></div>
            </div>
            <div class="table-box">
                <div class="table-box-header mini-scrollbar" ref="table_box_header" style="overflow-y: scroll">
                    <Row class="table-tr th" type="flex">
                        <Col class="table-td" style="width:8%">{{listHeader.mod_id}}</Col>
                        <Col class="table-td" style="width:12%">{{listHeader.org_level_cdesc}}
                            <myDropdown :list="org_levels" v-model="search.org_level"
                                        key_name="value" value_name="key"
                                        @onChange="onLevelsChange"></myDropdown>
                        </Col>
                        <Col class="table-td" style="width:15%">{{listHeader.mod_cname}}</Col>
                        <Col class="table-td" style="width:15%">{{listHeader.mod_cdesc}}</Col>
                        <Col class="table-td" style="width:20%">{{listHeader.add_time}}</Col>
                        <Col class="table-td" style="width:20%">{{$t('set_role')}}</Col>
                        <Col class="table-td" style="width:10%"></Col>
                    </Row>
                </div>
                <div class="table-box-content mini-scrollbar" ref="table_box_content" style="overflow-x: hidden" :style="table_box_content_style" @scroll="$base.setTableBoxContentScroll(self,false)">
                    <myNodata v-show="totalData.total <= 0" :last_time="search.search_time"></myNodata>
                    <Row class="table-tr even-line-bcolor" type="flex" align="middle" v-for="(item,index) in listData" :key="index">
                        <Col class="table-td" style="width:8%">{{item.mod_id}}</Col>
                        <Col class="table-td" style="width:12%">{{item.org_level_cdesc}}</Col>
                        <Col class="table-td" style="width:15%">{{item.mod_cname}}</Col>
                        <Col class="table-td" style="width:15%">{{item.mod_cdesc}}</Col>
                        <Col class="table-td" style="width:20%">{{item.add_time}}</Col>
                        <Col class="table-td" style="width:20%">
                            <div class="sub-table" v-for="(item2, index2) in item.roles" :key="index2">
                                <span class="sub-table-title">{{item2.cat_cname}}</span>
                                <span class="sub-table-content" style="cursor: pointer">
                                    <span class="f-blue" @click="openModRoleFunc(item2, item.mod_cname)">{{$t('configure')}}</span>
                                    <span class="f-red" @click="delModRole(item2.role_id)">{{$t('del')}}</span>
                                </span>
                            </div>
                            <a @click="openModRole(item.mod_id, item.mod_cname)">{{$t('add_role')}}</a>
                        </Col>
                        <Col class="table-td tcenter" style="width:10%"><a @click="openUpd(item)">{{$t('info')}}</a></Col>
                    </Row>
                </div>
                <div class="table-pager" v-show="totalData.total > 0">
                    <myPager :limit="search.limit" @onLimitChange="onLimitChange"
                             v-model="search.page" :pageSize="search.pageSize" @onPagerChange="onPagerChange"></myPager>
                </div>
            </div>
        </div>
        <!-- <download-excel :data="excelData" :fields="exportHeader" :name="export_title" v-show="false">
            <a type="success" ref="btn_excel"></a>
        </download-excel> -->
        <Drawer class="drawer-sub-view" :title="sub_title" v-model="show_subview" width="720" :mask-closable="false" placement="left" :closable="false">
            <router-view></router-view>
        </Drawer>
    </div>
</template>

<script>
    import myPager from '../../components/myPager'
    import myNodata from '../../components/myNodata'
    import myDropdown from '../../components/myDropdown'
    import myDatePicker from '../../components/myDatePicker'
    export default {
        name:"system-mod",
        components:{
            myPager,
            myNodata,
            myDropdown,
            myDatePicker
        },
        data:function(){
            const listHeader = {
                mod_id: "ID",
                org_level_cdesc: this.$t('org_level'),
                mod_cname: this.$t('mod_cname'),
                mod_cdesc: this.$t('mod_cdesc'),
                add_time: this.$t('add_time')
            };
            return{
                title: this.$t('gsreport_cp_dtl'),
                export_title: '',
                self:this,
                table_box_content_style: {
                    height:"200px"
                },
                table_box_content_fixed_style: {
                    height:"200px"
                },
                org_levels:[
                    {
                        key:'',
                        value:this.$t('all')
                    }
                ],
                sub_title:"",//子界面名称
                show_subview:false,
                relist:false,
                search:{
                    search_url: "mod/list",
                    search_time: new Date(),//最新查询时间
                    mod_cname: "",
                    date_fr: '',
                    date_to: '',
                    org_level:"",
                    page: 1,
                    limit: 30,
                    pageSize: 0
                },
                listHeader,//表结构
                listData: [],
                excelData: [],
                exportHeader : this.$base.changeJsonKeyValue(listHeader),
                totalData: {
                    total: 0,//总行数
                }
            }
        },
        activated:function(){
            this.$base.setMenuOpens();
        },
        mounted: function(){
            this.$base.setMenuOpens();
            this.setTable()
            this.getLoad();
        },
        methods:{
            setTable () {
                var table_box_height = this.$base.getTableBoxHeight(this.$refs['table_box_content']);
                this.table_box_content_style.height = table_box_height + 'px';
                table_box_height -= 10;
                this.table_box_content_fixed_style.height = table_box_height + 'px';
            },
            getLoad: function(){
                this.$base.showLoading();
                this.$request.sendPost("mod/before-list",{},(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.org_levels = this.org_levels.concat(data.org_level);
                        this.list();
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            onLevelsChange:function () {
                this.list();
            },
            onDateChange: function(data){
                this.search.date_fr = data[0];
                this.search.date_to = data[1];
            },
            onSearchTextChange: function(data){
                this.list();
            },
            onPagerChange: function () {
                this.list(true);
            },
            onLimitChange: function (limit) {
                this.search.limit = limit;
                this.list();
            },
            list: function (change_page) {
                if(!change_page) this.search.page = 1;
                this.search.search_time = new Date();
                this.$base.showLoading();
                this.$request.sendPost(this.search.search_url,this.search,(success,data,error)=>{
                    this.$base.hideLoading();
                    if(success){
                        this.listData = data.list;
                        this.search.pageSize = parseInt(data.last_page);
                        this.search.limit = parseInt(data.limit);
                        this.totalData.total = data.total.total;
                    }
                    else{
                        this.$base.alertErr(error.errmsg);
                    }
                });
            },
            exportExcel: function(){
                this.$base.exportExcel(this);
            },
            openAdd:function (item) {
                this.sub_title = this.$t('add_mod');
                this.$base.linkTo("/system/mod/save",{op: 'add', item: JSON.stringify(item)});
            },
            openUpd:function (item) {
                this.sub_title = this.$t('upd_mod');
                this.$base.linkTo("/system/mod/save",{op: 'upd', item: JSON.stringify(item)});
            },
            openModRole: function (id, mod_cname) {
                this.sub_title = this.$t('set_mod_role');
                this.$base.linkTo("/system/mod/selectRole",{id, mod_cname});
            },
            openModRoleFunc: function (item, mod_cname) {
                var data = {
                    role_cname: item.cat_cname,
                    role_id: item.role_id,
                    mod_id: item.mod_id,
                    mod_cname,
                };
                this.sub_title = this.$t('set_mod_role_func');
                this.$base.linkTo("/system/mod/roleFunc", {data: JSON.stringify(data)});
            },
            delModRole: function (role_id) {
                let content = this.$t('confirm_delete');
                let title =  this.$t('tips');
                this.$base.confirm(title,content, () => {
                    this.$base.showLoading();
                    this.$request.sendPost('mod/del-role',{role_id},(success,data,error)=>{
                        this.$base.hideLoading();
                        if(success){
                            this.$base.msgSuccess(error.errmsg);
                            this.list();
                        }
                        else{
                            this.$base.msgErr(error.errmsg);
                        }
                    });
                }, () => {})
            }
        },
        watch:{
            //界面重新加载数据
            relist:function (newVal,oldVal) {
                if(newVal){
                    this.list(this.search.page);
                    this.relist = false;
                }
            }
        }
    }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/system/mod.vue